import range from 'lodash/range';

/**
 * This function returns the rating based on the rating internal, rating limit and number of intervals
 */
function getRatings(minRatingValue, ratingInterval, numberOfIntervals) {
  const ratings = [];
  range(0, numberOfIntervals).forEach((rating) => {
    ratings.push(minRatingValue + rating * ratingInterval);
  });
  return ratings;
}

export default getRatings;
